import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {provideAuth} from './providers'

/**
 * Use this module with caution. It's used specifically to lazy load the AuthService which contains a lot of third
 * party code (aws amplify, cognito, etc)
 */
@NgModule({
  imports: [CommonModule],
  providers: [provideAuth()],
})
export class AuthModule {}
